<template>
    <div class="btn-group" style="margin-top: -25px">
        <button type="button" style="border:none" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span v-show="lg == 'en-en'">
                <img src="../../../assets/img/usa.png" style="width: 24px;position: relative;top: -1px;" alt=""> {{_traducao('pais','eua')}}
            </span>
            <span v-show="lg == 'pt-br'">
                <img src="../../../assets/img/brasil.png" style="width: 24px;height: 15px;position: relative;top: -2px;" alt=""> {{_traducao('pais','brasil')}}
            </span>
            <span v-show="lg == 'es-py'">
                <!-- <img src="../../../assets/img/paraguai.png" style="width: 24px;height: 15px;position: relative;top: -2px;" alt=""> {{_traducao('pais','paraguai')}} -->
                <img src="../../../assets/img/chile.jpg" style="width: 24px;height: 15px;position: relative;top: -2px;" alt=""> {{_traducao('pais','paraguai')}}
            </span>
            <span class="caret"></span>
        </button>
        <ul class="dropdown-menu">
            <li>
                <a href="#" @click.prevent="_setaLg('en-en')">
                    <img src="../../../assets/img/usa.png" style="width: 24px;position: relative;top: -1px;" alt=""> {{_traducao('pais','eua')}}
                </a>
            </li>
            <li>
                <a href="#" @click.prevent="_setaLg('pt-br')">
                    <img src="../../../assets/img/brasil.png" style="width: 24px;height: 15px;position: relative;top: -2px;" alt=""> {{_traducao('pais','brasil')}}
                </a>
            </li>
            <li>
                <a href="#" @click.prevent="_setaLg('es-py')">
                    <!-- <img src="../../../assets/img/paraguai.png" style="width: 24px;height: 15px;position: relative;top: -2px;" alt=""> {{_traducao('pais', 'paraguai')}} -->
                    <img src="../../../assets/img/chile.jpg" style="width: 24px;height: 15px;position: relative;top: -2px;" alt=""> {{_traducao('pais', 'paraguai')}}
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {

        computed: {
            lg (){
                return $sessao.getLang()
            },
        },
    }
</script>